interface ResultsIndicatorProps {
  pageIndex: number;
  pageSize: number;
  totalRows: number;
}

/**
 * Results indicator showing the current range of displayed rows
 * Example: "Showing 1-10 of 100 rows"
 */
export function ResultsIndicator({
  pageIndex,
  pageSize,
  totalRows,
}: ResultsIndicatorProps) {
  const startRow = totalRows === 0 ? 0 : pageIndex * pageSize + 1;
  const endRow = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <div className="flex items-center gap-1 px-2">
      <span className="text-sm text-muted-foreground">
        Showing{' '}
        <span className="font-medium text-foreground">
          {startRow}-{endRow}
        </span>{' '}
        of {totalRows} rows
      </span>
    </div>
  );
}
